<template>
    <div>
        <div
            @click="hideMenu"
            class="hamburger-nav"
        >

            <the-link
                className="nav-hamburger-li nav-hamburger-li-first"
                location="/"
                icon="white/home"
                iconWidth="20em"
                text="Domů"
            />

            <div v-for="(row, index) in navData">
                <template v-if="(($store.state.sklad.id_skladu != 12 && $store.state.sklad.id_skladu != 13) || (row['href'] == '/vydejky' || row['href'] == '/vydejky/nova-vydejka'))">
                    <the-link
                        className="nav-hamburger-li"
                        :location="row['href']"
                        :icon="'white/' + row['icon']"
                        iconWidth="20em"
                        :text="row['text']"
                        :counter="row['counter']"
                    />
                </template>
            </div>

        </div>
        <div
            class="nav-footer"
            @click="hideMenu"
        >
          <div class="row">
            <div class="col-12 text-center text-white">

            </div>
          </div>
            <the-link
                className="nav-hamburger-li nav-hamburger-li-user"
                location="/"
                icon="white/user"
                iconWidth="20em"
                :text="$store.state.uzivatel.prijmeni + ' ' + $store.state.uzivatel.jmeno"
            />
            <the-link
                className="nav-hamburger-li"
                location="/logout"
                icon="white/logout"
                iconWidth="20em"
                text="Odhlásit se"
            />
        </div>
    </div>
</template>

<script>
import TheIcon from "@/components/TheIcon";
import TheLink from "@/components/TheLink";
import axiosApiPostV2 from "@/router/axiosApiMethod";

export default {
    components: {TheIcon, TheLink},
    data() {
        return {
            userName: '',
            navData: '',
        }
    },
    methods: {
        hideMenu() {
            this.$root.$emit('hideMenuBus', true)
        },
      async getMenu() {
        Helper.getMenu().then( result => {
          this.navData = result;
          this.$root.$emit('showLoader', {show: false});
        });
      }
    },
   created() {
        this.userName = localStorage.getItem("userName");
        this.$root.$emit('showLoader', {show: true});
        this.getMenu();
    }
}


</script>

<style lang="scss" scoped>
@import "../../assets/scss/colors.scss";

.hamburger-nav {
    position: absolute;
    background: $theme-black;
    height: 75%;
    width: 100%;
    top: 5%;
    overflow: auto;
}


.hamburger-nav::-webkit-scrollbar {
    background: $theme-black;
    color: $theme-black;
    width: 1px;
}

.hamburger-nav::-webkit-scrollbar-track {
    background: $theme-black;
    width: 1px;
}

.nav-hamburger-li {
    display: list-item;
    list-style: none;
    padding-top: 1.5em;
    padding-bottom: 0em;
    padding-left: 1em;
    font-family: Arial, Helvetica, Verdana, sans-serif;
}

.nav-hamburger-li-user {
    font-size: 0.8em;
}

.nav-hamburger-li-first {
    padding-top: 0em;
}

a {
    color: $theme-white;
    font-weight: bold;
}

a:hover {
    text-decoration: none;
    color: $color-dark;
}

.nav-footer {
    position: absolute;
    width: 100%;
    border-top: 1px solid $theme-red;
    height: 19%;
    top: 81%;
    .nav-hamburger-li {
        padding-top: 10px;
    }
}

.hamburger-nav, .nav-footer {
    a:hover {
        color: $color-black;
    }
}

</style>
